import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { BROADCASTVIEWS } from "common/viewContent";
import Helmet from "react-helmet";
import * as Path from "routes/Path/index";
import BackButtom from "components/BackButtom";
import { toast } from "react-toastify";
import { getBroadcastDetail } from "store/actions";
import EmailsTable from "./EmailsTable";
import Pagination from "components/Pagination";
import sanitizeHtml from "sanitize-html";
import "react-quill/dist/quill.snow.css";
const index = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [search_text, setSearch_text] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);
  // const [pageSize, setPageSize] = useState(20);
  useEffect(() => {
    fetchData();
  }, [id]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search_text);
    }, 500); 
  
    return () => clearTimeout(handler); 
  }, [search_text]);



  const fetchData = () => {
    if (id) {
      setLoading(true);
      dispatch(
        getBroadcastDetail({
          id,
          callback: (err, res) => {
            if (err) {
              toast.error(err);
              setLoading(false);
            } else {
              setData(res?.data);
              setLoading(false);
              // toast.success(res.message);
            }
          },
        })
      );
    }
  };
  const filteredEmails = data?.emails.filter((email) =>
    email.toLowerCase().includes(debouncedSearch.toLowerCase())
  );
  // const handlePageChange = ({ selected }) => {
  //   setCurrentPage(selected + 1);
  // };
  // const startIndex = (currentPage - 1) * pageSize;
  // const endIndex = startIndex + pageSize;
  // const paginatedEmails = data?.emails?.slice(startIndex, endIndex) || [];
  const sanitizedMsg = sanitizeHtml(data?.msg || "N/A", {
    allowedTags: false, // Allow ALL tags
    allowedAttributes: false, // Allow ALL attributes
    allowedStyles: { "*": { "text-align": [/^left$/, /^right$/, /^center$/, /^justify$/] } }, // Keep text alignment styles
  });

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={BROADCASTVIEWS.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <BackButtom />
          <h1>{BROADCASTVIEWS.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.broadcast}>Broadcast</Link>
            </div>
            <div className="breadcrumb-item">
              {BROADCASTVIEWS.CURRENT_MODULE}
            </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">
                    {BROADCASTVIEWS.TOP_CONTENT}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          {!loading && data && (
            <div className="card p-3">
              <div className="border-bottom text-center mb-3">
                <h6 className="p-2">Broadcast Details</h6>
              </div>

              <div className="row mb-3">
                <div className="col-md-6 ">
                  <p className="mb-0">
                    <strong>Subject:</strong>
                  </p>
                  {data?.subject || "N/A"}
                </div>
                <div className="col-md-6">
                  <p className="mb-0">
                    <strong>Type:</strong> {data?.type || "N/A"}
                  </p>
                </div>
              </div>

              {/* <div className="row">
                <div className="col-12">
                  <p className="mb-0">
                    <strong>Message:</strong> 
                    <div dangerouslySetInnerHTML={{ __html: sanitizedMsg }} />
                  </p>
                </div>
              </div> */}
              <div className="row">
                <div className="col-12">
                  <div className="mb-0">
                    <strong>Message:</strong>
                    <div dangerouslySetInnerHTML={{ __html: sanitizedMsg }} />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="card p-3">
            {!loading && data?.emails && (
              <>
                <div className="border-bottom d-flex justify-content-between align-items-center mb-3 pb-2">
                  <h6 className="p-2 m-0">Emails</h6>
                  <div>
                    <input
                      className="form-control"
                      name="search_text"
                      onChange={(e) => setSearch_text(e.target.value)}
                      value={search_text}
                      placeholder="Search email..."
                      style={{
                        width: "250px",
                        height: "36px",
                        fontSize: "14px",
                      }}
                    />
                  </div>
                </div>

                {/* <EmailsTable data={paginatedEmails} currentPage={currentPage} pageSize={pageSize} /> */}
                <div className="d-flex flex-wrap gap-2">
                  {filteredEmails.map((val, idx) => (
                    <span
                      key={idx}
                      className="badge bg-primary rounded-pill px-3 py-2"
                    >
                      {val}
                    </span>
                  ))}
                </div>
              </>
            )}
             {filteredEmails && filteredEmails.length === 0 && (
              <p className="text-center py-5">No Email Found</p>
            )}
            {!loading && data?.emails === 0 && (
              <p className="text-center py-5">No Data Found</p>
            )}
            {/* {!loading && data?.emails && data?.emails?.length > 0 && (
              <Pagination
                pageCount={Math.ceil(data?.emails?.length / pageSize)}
                onPageChange={handlePageChange}
                itemsPerPage={pageSize}
                totalItems={data?.emails?.length}
                currentPage={currentPage}
              />
            )} */}
          </div>
        </div>
      </section>
    </>
  );
};
export default index;
